import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default (props) => {
  const { message, position, duration, progress, type, onClose } = props;
  return toast(message, {
    position: position || "top-right",
    autoClose: duration || 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    newestOnTop: true,
    type: type,
    onClose: onClose,
    theme: "colored",
  });
};
